import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["company", "input"]

  connect() {
    this.companyTargets.forEach(company => {
      company.style.display = "block"
    })
  }

  filter() {
    const searchTerm = this.inputTarget.value.toLowerCase().trim()
  
    this.companyTargets.forEach(company => {
      const companyName = company.querySelector("p:nth-child(1)")?.textContent?.toLowerCase() || ""
      const displayedName = company.querySelector("p:nth-child(2)")?.textContent?.toLowerCase() || ""
  
      if (
        searchTerm === "" ||
        companyName.includes(searchTerm) ||
        displayedName.includes(searchTerm)
      ) {
        company.style.display = "block"
      } else {
        company.style.display = "none"
      }
    })
  }
}
